import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import axios from ".././axios-interceptor";
import InvestorSideNavBar from "./SideNavBarInvestor";
import InvestorNavBarMain from "./InvestorNavBar";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import { base_url } from "./../utilities";

const PendingApprovals = () => {
  const navigate = useNavigate();

  const [investorData, setInvestorData]       = useState({});
  const [pendingList, setPendingList]         = useState([]);
  const [loading, setLoading]                 = useState(true);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showModal, setShowModal]             = useState(false);
  const [schedule, setSchedule]               = useState([]);
  const [currentSchedule, setCurrentSchedule] = useState([]);
  const [remarks, setRemarks]                 = useState('');
  const [submitting, setSubmitting]           = useState(false);

  useEffect(() => {
    if (Cookies.get("User_Accesstoken_Investor") == null) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    axios
      .post(base_url + "investor-master/get_investor_master_user", {
        user_id: Cookies.get("investor_user_id"),
      })
      .then((res) => {
        setInvestorData(res?.data?.data);
        fetchPendingApprovals(res?.data?.data?.investor_id);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          toast.error("Your session has expired. Please login again", { toastId: 7 });
          Cookies.remove("User_Accesstoken_Investor");
          Cookies.remove("User_Refreshtoken_Investor");
          navigate("/");
        }
      });
  }, []);

  const fetchPendingApprovals = (investor_id) => {
    axios
      .post(base_url + "service-request-trx/get_pending_extensions", {
        investor_id,
      })
      .then((res) => {
        setPendingList(res?.data?.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // Fetch the pending schedule rows for this loan to show in modal
  const handleViewRequest = (request) => {
    setSelectedRequest(request);
    setRemarks('');
    setShowModal(true);
    axios
      .post(base_url + "service-request-trx/get_pending_schedule", {
        loan_id: request.loan_id,
      })
      .then((res) => {
        setSchedule(res?.data?.new_extension_schedule || res?.data?.data || []);
      })
      .catch((err) => console.log(err));
  };

  const handleDecision = (decision) => {
    if (submitting) return;
    setSubmitting(true);

    axios
      .post(base_url + "service-request-trx/investor_extension_decision", {
        service_request_id: selectedRequest.service_request_id,
        loan_id:            selectedRequest.loan_id,
        investor_id:        investorData.investor_id,
        decision,
        remarks,
      })
      .then((res) => {
        toast.success(
          decision === 'approved'
            ? 'Extension approved successfully'
            : 'Extension rejected'
        );
        setShowModal(false);
        setSelectedRequest(null);
        setSchedule([]);
        setCurrentSchedule([]);
        // Refresh list
        fetchPendingApprovals(investorData.investor_id);
      })
      .catch((err) => {
        toast.error('Something went wrong. Please try again.');
        console.log(err);
      })
      .finally(() => setSubmitting(false));
  };

  const TYPE_LABELS = {
    'Equal Extension':                            'Equal Extension',
    'Equal Extension with Principal Deferral':    'Principal Deferral',
    'Equal Extension with Total Deferral':        'Total Deferral',
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <InvestorSideNavBar />
      <main style={{ width: "100%" }}>
        <InvestorNavBarMain businessname={investorData?.investor_name} />

        <div className="content_main_body db_body d-block">
          <div className="row d-flex flex-column">
            <div className="col d-flex justify-content-between mt-1">
              <div className="investor_new_first_tab">
                Approvals
                {pendingList.length > 0 && (
                  <span style={{
                    marginLeft: 10,
                    background: '#185FA5',
                    color: '#fff',
                    borderRadius: 12,
                    fontSize: 12,
                    padding: '2px 10px',
                    fontWeight: 500,
                    verticalAlign: 'middle'
                  }}>
                    {pendingList.length}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col mt-3 myinvestmts_table_div">
              {!loading && pendingList.length === 0 ? (
                <div style={{
                  textAlign: 'center',
                  color: '#888',
                  padding: '60px 0',
                  fontSize: 15
                }}>
                  No pending approvals
                </div>
              ) : (
                <Table striped className="my_loan_table">
                  <thead>
                    <tr>
                      {['Loan Ref No.', 'Business Name', 'Months', 'Loan Amount', 'Requested On', 'Actions'].map(h => (
                        <th key={h}>
                          {loading ? <Skeleton width={80} height={15} /> : <>{h} &#9662;</>}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {loading
                      ? [...Array(3)].map((_, i) => (
                          <tr key={i}>
                            {[...Array(7)].map((_, j) => (
                              <td key={j}><Skeleton width={90} height={15} /></td>
                            ))}
                          </tr>
                        ))
                      : pendingList.map((item, index) => (
                          <tr key={index}>
                            <td>{item.loan_reference_number}</td>
                            <td>{item.business_name || '—'}</td>
                            <td>{item.extend_tenure} month{item.extend_tenure > 1 ? 's' : ''}</td>
                            <td>BHD {Number(item.loan_amount).toLocaleString()}</td>
                            <td>{moment(item.created_date_time).format('DD MMM YYYY')}</td>
                            <td>
                              <img
                                src="./images/icons/double_arrow.svg"
                                alt="view"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleViewRequest(item)}
                              />
                            </td>
                          </tr>
                        ))
                    }
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        </div>

        {/* ── Modal ── */}
        {showModal && selectedRequest && (
          <div style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.45)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 12,
              width: '100%',
              maxWidth: 780,
              maxHeight: '90vh',
              overflowY: 'auto',
              fontFamily: 'sans-serif'
            }}>

              {/* Modal header */}
              <div style={{
                display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', padding: '16px 20px',
                borderBottom: '1px solid #eee'
              }}>
                <span style={{ fontWeight: 600, fontSize: 16 }}>
                  Extension approval request
                </span>
                <span
                  style={{ cursor: 'pointer', fontSize: 20, color: '#888' }}
                  onClick={() => { setShowModal(false); setSchedule([]); setCurrentSchedule([]); }}
                >
                  &times;
                </span>
              </div>

              {/* Loan meta */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: 16, padding: '16px 20px',
                borderBottom: '1px solid #eee'
              }}>
                {[
                  { label: 'Loan ref no.',    value: selectedRequest.loan_reference_number },
                  { label: 'Business name',   value: selectedRequest.business_name || '—' },
                  { label: 'Loan amount',     value: `BHD ${Number(selectedRequest.loan_amount).toLocaleString()}`},
                  { label: 'Months',          value: `${selectedRequest.extend_tenure} month${selectedRequest.extend_tenure > 1 ? 's' : ''}` },
                  { label: 'Requested on',    value: moment(selectedRequest.created_date_time).format('DD MMM YYYY') },
                ].map(({ label, value }) => (
                  <div key={label}>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>{label}</div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>{value}</div>
                  </div>
                ))}
              </div>

              {/* New extension schedule */}
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee' }}>
                <div style={{
                  fontSize: 12, fontWeight: 600,
                  color: '#555', marginBottom: 10,
                  textTransform: 'uppercase', letterSpacing: '0.04em'
                }}>
                  New extension schedule
                </div>
                <Table striped style={{ fontSize: 13 }}>
                  <thead>
                    <tr>
                      {['Month', 'Tenure date', 'Principal (BHD)', 'Interest (BHD)', 'Total (BHD)', 'Note'].map(h => (
                        <th key={h} style={{ fontSize: 11, fontWeight: 500, color: '#888' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {schedule.length === 0
                      ? [...Array(3)].map((_, i) => (
                          <tr key={i}>
                            {[...Array(6)].map((_, j) => (
                              <td key={j}><Skeleton height={14} /></td>
                            ))}
                          </tr>
                        ))
                      : schedule.map((row, i) => (
                          <tr key={i} style={{
                            fontStyle: row.is_deferral_month ? 'italic' : 'normal',
                            color: row.is_bullet_payment
                              ? '#185FA5'
                              : row.is_deferral_month ? '#888' : 'inherit',
                            fontWeight: row.is_bullet_payment ? 600 : 400
                          }}>
                            <td>{i + 1}</td>
                            <td>{moment(row.tenure_date).format('DD MMM YYYY')}</td>
                            <td>{row.is_deferral_month ? '—' : `BHD ${Number(row.principal).toFixed(2)}`}</td>
                            <td>{row.is_deferral_month ? '—' : `BHD ${Number(row.investor_profit).toFixed(2)}`}</td>
                            <td>{row.is_deferral_month ? 'BHD 0.00' : `BHD ${Number(row.tenure_amount_investor_roi).toFixed(2)}`}</td>
                            <td style={{ fontSize: 11, color: '#888' }}>
                              {row.is_bullet_payment
                                ? 'Bullet payment'
                                : row.is_deferral_month
                                ? 'Deferral – no collection'
                                : row.extension_type
                                ? row.extension_type
                                : 'Original'}
                            </td>
                          </tr>
                        ))
                    }
                  </tbody>
                </Table>
              </div>

              {/* Remarks + actions */}
              <div style={{ padding: '14px 20px' }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>
                  Remarks (optional)
                </div>
                <textarea
                  rows={3}
                  placeholder="Add a note for your records..."
                  value={remarks}
                  onChange={e => setRemarks(e.target.value)}
                  style={{
                    width: '100%', fontSize: 13,
                    padding: '8px 10px', borderRadius: 6,
                    border: '1px solid #ddd', resize: 'vertical',
                    marginBottom: 16, outline: 'none'
                  }}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                  <button
                    onClick={() => { setShowModal(false); setSchedule([]); setCurrentSchedule([]); }}
                    style={{
                      padding: '8px 20px', borderRadius: 6, fontSize: 13,
                      border: '1px solid #ddd', background: '#fff',
                      cursor: 'pointer', fontWeight: 500
                    }}
                  >
                    Close
                  </button>
                  <button
                    onClick={() => handleDecision('rejected')}
                    disabled={submitting}
                    style={{
                      padding: '8px 20px', borderRadius: 6, fontSize: 13,
                      border: '1px solid #F09595', background: '#FCEBEB',
                      color: '#791F1F', cursor: 'pointer', fontWeight: 500
                    }}
                  >
                    {submitting ? 'Processing...' : 'Reject'}
                  </button>
                  <button
                    onClick={() => handleDecision('approved')}
                    disabled={submitting}
                    style={{
                      padding: '8px 20px', borderRadius: 6, fontSize: 13,
                      border: 'none', background: '#185FA5',
                      color: '#fff', cursor: 'pointer', fontWeight: 500
                    }}
                  >
                    {submitting ? 'Processing...' : 'Approve'}
                  </button>
                </div>
              </div>

            </div>
          </div>
        )}

      </main>
    </div>
  );
};

export default PendingApprovals;